(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["payfem-collection-grid"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown', function(event) {
  const label = event.target.closest('.payfem-card-swatches .m-product-option--node__label[role="button"]');
  if (label && (event.key === 'Enter' || event.key === ' ')) {
    event.preventDefault();
    label.click();
  }
});

  } catch(e) { console.error(e); }
})();
})();
